import React from 'react'

const AboutMe = () => {
    return (
        <div id='about' className='min-h-[105vh] sm:min-h-[90vh] w-full relative container p-0 ' >
            <h5 className='relative top-0 flex ms-auto right-10 p-0 fw-bold
             text-violet-300 text-opacity-20 uppercase text-9xl m-0
    vrl sm:text-9xl md:text-[14rem] lg:text-[16rem] bebas text-nowrap' >About Me </h5>
            {/* Container */}

            <main className='container row absolute top-1/2 left-1/2
             -translate-y-1/2 -translate-x-1/2 min-h-[10vh] ' >
                <section className='col-lg-5 my-3 ' >
                    <img src={require('../Assset/computerImg.webp')} alt="Computer" className='w-4/5 lg:w-3/5 lg:mx-auto ' />
                </section>
                <section className='col-lg-5 poppins flex items-center mt-3 ' >
                    <article>
                        <h5 className='text-5xl my-3 sm:text-5xl lg:text-7xl bebas ' > Jerold raja </h5>
                        <p className='mb-0 ' >
                            I’m a Full Stack Developer and Team Lead with 2+ years of experience building scalable web applications using the MERN stack and Next.js. I focus on backend systems, API design, and performance optimization, with proven improvements in query efficiency and system reliability.
                            <br /> <br /> Currently, I lead a team of 5 developers, handling end-to-end development — from system design to deployment. I’ve built multiple production applications, including e-commerce platforms, social apps, HRMS tools, and a bulk mail system handling 40,000+ recipients.
                            <br /> <br /> I enjoy solving real-world engineering problems and building systems that are efficient, scalable, and user-focused.
                        </p>
                        {/* <p className='mb-0 mt-4 ' >Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam cum soluta pariatur impedit quia maiores totam
                            doloremque corrupti laboriosam, commodi recusandae eveniet a culpa quos fugiat nobis ipsum.
                            Facere sed minus laudantium ipsam
                            alias laboriosam vitae reprehenderit eum, qui porro? </p> */}
                    </article>
                </section>

            </main>
        </div>
    )
}

export default AboutMe